import {
  SlTag
} from "./chunk.RNK5BM2Z.js";

// src/components/tag/tag.ts
var tag_default = SlTag;
SlTag.define("sl-tag");

export {
  tag_default
};
